module.exports = __webpack_public_path__ + "img/benzinga.3a1e45a9.png";